import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, MonthlyReportMail } from "../stores/store_types"

const callMonthlyReportMailsFindAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, result: MonthlyReportMail) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/monthly_report_mails/find",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callFixMonthlyReportMailsAPI = (headers: AuthHeaders, monthlyReportMail: MonthlyReportMail, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: (error: AxiosError) => void) => {
  axios.post(
    "/api/v1/monthly_report_mails/fix",
    {
      monthly_report_mail: {
        corporation_id: monthlyReportMail.corporationId,
        from: monthlyReportMail.from,
        to: monthlyReportMail.to,
        year: monthlyReportMail.year,
        month: monthlyReportMail.month,
        title: monthlyReportMail.title,
        body: monthlyReportMail.body
      }
    },
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    failureCallback(error)
  })
}
const callSaveDraftMonthlyReportMailsAPI = (headers: AuthHeaders, monthlyReportMail: MonthlyReportMail, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.post(
    "/api/v1/monthly_report_mails/save_draft",
    {
      monthly_report_mail: {
        corporation_id: monthlyReportMail.corporationId,
        from: monthlyReportMail.from,
        to: monthlyReportMail.to,
        year: monthlyReportMail.year,
        month: monthlyReportMail.month,
        title: monthlyReportMail.title,
        body: monthlyReportMail.body
      }
    },
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callCancelMonthlyReportMailAPI = (headers: AuthHeaders, id: number, successCallback: (headers: AxiosResponseHeaders, status: number) => void, failureCallback: () => void) => {
  axios.put(
    `/api/v1/monthly_report_mails/${id}/cancel`,
    {},
    {
      headers: headers,
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.status)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
export { callMonthlyReportMailsFindAPI, callFixMonthlyReportMailsAPI, callSaveDraftMonthlyReportMailsAPI, callCancelMonthlyReportMailAPI }
